export default {"src":"/_next/static/image/public/images/ic_verified.26698b18fbc6504bbd04931163952396.svg","height":16,"width":16};